
import { IconArchive } from '@/public/assets/icons/IconArchive';
import { IconFavorites } from '@/public/assets/icons/IconFavorites';
import { AccessEnum, NavMenuType } from './types';
import { SearchExpand } from './components/SearchExpand';
import { FavoritesExpand } from './components/FavoritesExpand';
import { ArchiveExpand } from './components/ArchiveExpand';
import { IconAccess } from '@/public/assets/icons/IconAccess';
import { IconBook } from '@/public/assets/icons/IconBook';
import { IconTemplate } from '@/public/assets/icons/IconShablon';
import { IconSearchSideBar } from '@/public/assets/icons/IconSearchSideBar';


export const NAV_MENU: NavMenuType[] = [
  {
    id: '0',
    pathname: '/fastSearch',
    title: 'Быстрый поиск',
    icon: <IconSearchSideBar width={'25px'} height={'20px'}/>,
    access: [AccessEnum.ADMIN],
    isDisabled: true
  },
  {
    id: '1',
    pathname: '/search',
    title: 'Экран поиска',
    icon: <IconSearchSideBar width={'24px'} height={'24px'}/>,
    isExpand: true,
    expandElement: <SearchExpand />,
    access: [AccessEnum.ADMIN]
  },
  {
    id: '2',
    pathname: '/favorites',
    title: 'Избранное',
    icon: <IconFavorites width={'24px'} height={'24px'}/>,
    isExpand: true,
    expandElement: <FavoritesExpand />,
    access: [AccessEnum.ADMIN, AccessEnum.USER]
  },
  {
    id: '3',
    pathname: '/archive',
    title: 'Архив',
    icon: <IconArchive width={'24px'} height={'24px'}/>,
    isExpand: true,
    expandElement: <ArchiveExpand />,
    access: [AccessEnum.ADMIN, AccessEnum.USER]
  },
  {
    id: '4',
    pathname: '/access',
    title: 'Доступы',
    icon: <IconAccess width={'24px'} height={'24px'}/>,
    access: [AccessEnum.ADMIN, AccessEnum.LOCAL_ADMIN]
  },
  {
    id: '5',
    pathname: '/sources',
    title: 'Источники',
    icon: <IconBook width={'22px'} height={'24px'}/>,
    access: [AccessEnum.ADMIN]
  },
  {
    id: '6',
    pathname: '/template',
    title: 'Шаблоны',
    icon: <IconTemplate width={'22px'} height={'22px'}/>,
    access: [AccessEnum.ADMIN]
  },
];


